import { StatusBadge, type Tone } from "@nymbl/nos2-rules";
import { TIME_ENTRY_TYPE_OPTIONS, type TimeEntryType } from "@/lib/enums";

const LABELS = Object.fromEntries(
  TIME_ENTRY_TYPE_OPTIONS.map((option) => [option.value, option.label]),
);

const TONES: Record<TimeEntryType, Tone> = {
  billable: "info",
  nonbillable: "warning",
  internal: "neutral",
  presales: "info",
  pto: "success",
};

export function TypeChip({ type }: { type: TimeEntryType }) {
  return <StatusBadge status={type} tones={TONES} labels={LABELS} />;
}
